// YERİ: src/app/domains/site/sections/edu-programs.section.ts
// Eğitim — Programlar / Kurslar grid'i (ikon + başlık + açıklama + süre/seviye etiketi).

import { Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';

interface Program { icon?: string; title: string; description?: string; meta?: string; }

@Component({
  selector: 'sec-edu-programs',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="programs" class="bg-white py-24 dark:bg-neutral-950">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          @if (subtitle()) { <p class="mt-4 text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p> }
        </div>
        <div class="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          @for (p of items(); track p.title) {
            <div class="group flex flex-col rounded-2xl border border-neutral-200 bg-white p-7 transition hover:-translate-y-1 hover:shadow-xl dark:border-neutral-800 dark:bg-neutral-900">
              <div class="flex size-12 items-center justify-center rounded-xl text-white" style="background-color:var(--site-primary)">
                <m-icon [name]="p.icon || 'book-open'" size="md" />
              </div>
              <h3 class="mt-5 text-lg font-semibold text-neutral-900 dark:text-white">{{ p.title }}</h3>
              @if (p.description) { <p class="mt-2 flex-auto text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">{{ p.description }}</p> }
              @if (p.meta) {
                <span class="mt-4 inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-medium" style="background-color:color-mix(in srgb, var(--site-accent) 18%, transparent); color:var(--site-accent)">
                  <m-icon name="clock" size="xs" /> {{ p.meta }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class EduProgramsSection {
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Programlarımız'));
  protected title = computed(() => cfg(this.config(), 'title', 'Eğitim Programları'));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', 'Her yaş ve seviyeye uygun, geleceğe hazırlayan programlarımızı keşfedin.'));
  protected items = computed<Program[]>(() => cfg<Program[]>(this.config(), 'items', [
    { icon: 'calculator', title: 'Matematik & Fen', description: 'Analitik düşünme ve problem çözme odaklı temel bilim eğitimi.', meta: 'Tüm seviyeler' },
    { icon: 'languages', title: 'Yabancı Dil', description: 'İngilizce ağırlıklı, konuşma pratiği destekli dil programı.', meta: 'A1–C1' },
    { icon: 'code', title: 'Kodlama & Robotik', description: 'Geleceğin becerileri: yazılım, algoritma ve robotik atölyeleri.', meta: '8+ yaş' },
    { icon: 'palette', title: 'Sanat & Tasarım', description: 'Yaratıcılığı geliştiren görsel sanatlar ve tasarım dersleri.', meta: 'Tüm yaşlar' },
    { icon: 'music', title: 'Müzik', description: 'Bireysel ve grup enstrüman eğitimi, koro ve solfej.', meta: 'Başlangıç–İleri' },
    { icon: 'graduation-cap', title: 'Sınava Hazırlık', description: 'LGS ve YKS için planlı, ölçme-değerlendirmeli hazırlık.', meta: 'Ortaokul–Lise' },
  ]));
}
